module.exports = __webpack_public_path__ + "img/xr1.8d021f79.png";